console.log("Accessibility scripts loaded");
document.addEventListener("DOMContentLoaded", () => {
  // specific to Grayl megamenu as of Septeber 8 2023, will need to be modified with each megamenu change
  let mega = document.querySelectorAll(".mega-menu__image-wrapper");
  mega[0].setAttribute("aria-label","Purifier Bottle Collection");
  mega[1].setAttribute("aria-label","Cartridge Replacement Collection");
  mega[2].setAttribute("aria-label","Camp & Drinkware Collection");
  mega[3].setAttribute("aria-label","Packs & Transport Collection");
  mega[4].setAttribute("aria-label","Replacement Parts Collection");

  let accessibilityLink = document.querySelector(".site-footer__linklist li a[href='/#']");
  accessibilityLink.setAttribute("data-awam-target","true");
});
window.onload = function() {
  let formIframeGuarantee = document.querySelector("#bdbvy iframe");
  if(formIframeGuarantee) {
    formIframeGuarantee.setAttribute("title","Guarantee Form")
  };
  let formIframeReturns = document.querySelector("#fc456d iframe");
  if(formIframeReturns) {
    formIframeReturns.setAttribute("title","Returns Form")
  };
  let formIframeReachout = document.querySelector("#bnclm iframe");
  if(formIframeReachout) {
    formIframeReachout.setAttribute("title","Reach Out Form")
  };
};